import { Component, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { SettingsService } from '../settings/settings.service'
import { ToastrService } from 'ngx-toastr'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { FincartIntegrateDialogComponent } from './fincart-integrate-dialog/fincart-integrate-dialog.component'

@Component({
  selector: 'app-fin-cart',
  templateUrl: './fin-cart.component.html',
  styleUrl: './fin-cart.component.scss'
})
export class FinCartComponent implements OnInit {
  fincartApiKey: string = ''
  isActivated: boolean = false
  saving: boolean = false
  showApiKeyInput: boolean = false
  justActivated: boolean = false
  registeredFincart: boolean = false

  constructor(
    private settingsService: SettingsService,
    private toastrService: ToastrService,
    private builderService: BuilderService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loadFincartKey()
  }

  loadFincartKey(): void {
    this.settingsService.getSettings().subscribe((settings: any) => {
      if (settings?.fincartApiKey) {
        this.fincartApiKey = settings.fincartApiKey
        this.isActivated = true
        this.builderService.fincartActive = true
        this.builderService.fincartApiKey = settings.fincartApiKey
      }else if(settings?.registeredFincart){
        this.registeredFincart = settings.registeredFincart
      }
    })
  }

  activateFincart(): void {
    if (!this.fincartApiKey) return

    this.saving = true
    this.settingsService.submitSettings({ fincartApiKey: this.fincartApiKey }).subscribe({
      next: () => {
        this.saving = false
        this.justActivated = true
        setTimeout(() => {
          this.isActivated = true
          this.showApiKeyInput = false
          this.toastrService.success('Fincart shipping activated successfully', 'Success')
          this.builderService.fincartActive = true
          this.builderService.fincartApiKey = this.fincartApiKey
        }, 500)
      },
      error: () => {
        this.saving = false
        this.toastrService.error('Failed to activate Fincart shipping', 'Error')
      }
    })
  }

  deactivateFincart(): void {
    this.saving = true
    this.settingsService.submitSettings({ fincartApiKey: '' }).subscribe({
      next: () => {
        this.fincartApiKey = ''
        this.isActivated = false
        this.saving = false
        this.toastrService.success('Fincart shipping deactivated', 'Success')
        this.builderService.fincartActive = false
        this.builderService.fincartApiKey = ''
      },
      error: () => {
        this.saving = false
        this.toastrService.error('Failed to deactivate Fincart shipping', 'Error')
      }
    })
  }

  openIntegrateDialog(): void {
    const dialogRef = this.dialog.open(FincartIntegrateDialogComponent, {
      width: '632px',
      panelClass: 'fincart-dialog-panel'
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.showApiKeyInput = true
      }
    })
  }
}
